import { ITag } from "@/types/strapi";

function Tag({ color, name }: ITag) {
	const bgColor = { backgroundColor: color || undefined };
	return (
		<span
			className={`inline-block rounded-full px-3 py-1 text-sm  ${
				bgColor.backgroundColor ? "" : "bg-gray-100 text-gray-800"
			}`}
			style={bgColor}
		>
			{name}
		</span>
	);
}
export default Tag;
